import { ISearchPage, IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";


//详情
export interface IIntroductionsDetail {
    code?: string,
    createTime?: string,
    createUser?: string,
    deleteFlag?: string,
    qrCode?: string,
    id?: string,
    name?: string,
    orderNum?: string,
    page?: string,
    photo?: string,
    profiles?: string,
    updateTime?: string,
    updateUser?: string,
    html?: string,
}

//新增
export interface IIntroductionsInsert extends IIntroductionsDetail {
}

//编辑
export interface IIntroductionsUpdate extends IIntroductionsInsert {
    id: string,
}

//搜索条件
export interface IIntroductionsSearchFields {
    enable?: string,      // "分支",
    stuats?: string,      // "状态",
    orgCode?: string,      // "机构编码",
    name?: string,      // "门店名称",
    sourceApp?: string,      // "mdm",
}
export interface ICmSearchPageFields {
    page: ISearchPage;
}
export interface IIntroductionsSearch
    extends IIntroductionsSearchFields, ICmSearchPageFields {
}

//表单字段
export interface IIntroductionsFormFields {
    "id"?: string,  // "819ae0df7201b429f272ace799fe9c3c", 
    "name"?: string,  // "业务修改", 
    "code"?: string,  // "1230", 
    "photo"?: string[],  // "234", 
    "qrCode"?: string[],  // "234", 
    "profiles"?: any,  // "简介" 
    "html"?: any,  // "简介" 
}

class IntroductionsService {
    async page(searchVo: IIntroductionsSearch) {
        const apiUrl = "/ebc/business/search/pg";
        return await httpRequest.post<IPage<IIntroductionsDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/ebc/business/select/${id}`;
        return await httpRequest.get<IIntroductionsDetail>(apiUrl);
    }
    async insert(insertVo: IIntroductionsInsert) {
        const apiUrl = "/ebc/business/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: IIntroductionsUpdate) {
        const apiUrl = "/ebc/business/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //启用禁用
    async disable(id: string) {
        const apiUrl = `/ebc/business/delete/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }

}

export const introductionsService = new IntroductionsService();
